import debounce from "~/store/manage/utilities/debounce";

import extractId from "~/components/forms/utilities/extractId";
import extractAction from "~/components/forms/utilities/extractAction";

const dispatch = async (store, action, { id, field, value, index }) => {
  await store.dispatch(action, { id, field, value, index });
};

const dispatchWithDebounce = debounce(dispatch, 500);

export function createModelWithDebounce() {
  return {
    get() {
      return this.item[this.fieldName];
    },
    set(value) {
      const action = extractAction.call(this);
      const id = extractId.call(this);
      const field = this.fieldName;
      const index = this.index;

      dispatchWithDebounce(this.$store, action, { id, field, value, index });
    },
  };
}

export default function createModel() {
  return {
    get() {
      return this.item[this.fieldName];
    },
    set(input) {
      const action = extractAction.call(this);
      const id = extractId.call(this);
      const field = this.fieldName;
      const index = this.index;

      let value = input;

      // eslint-disable-next-line no-prototype-builtins
      if (this.hasOwnProperty("trimValue") && this.trimValue === true) {
        value = value.toString().trim();
      }

      if (action) {
        dispatch(this.$store, action, { id, field, value, index });
      } else {
        this.item[field] = value;
      }
    },
  };
}
